import { motion } from "framer-motion";
import { Search, Filter } from "lucide-react";
import { useState } from "react";
import AdvancedSearchDrawer from "./AdvancedSearchDrawer";

export default function SecondaryFilters({ tab, onTabChange, disableOpen, open, onOpenChange, onApply }) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = open ?? internalOpen;
  const setOpen = onOpenChange ?? setInternalOpen;
  
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      {/* Search with Filter Icon */}
      <div className="flex items-center gap-2 w-full md:w-auto">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 text-gray-400 -translate-y-1/2">
            <Search size={16} />
          </span>
          <input
            type="text"
            placeholder="Search providers"
            className="py-2 pr-3 pl-8 w-full text-sm bg-white rounded-lg border outline-none border-emerald-300/60 focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 placeholder:text-gray-400"
          />
        </div>
        <motion.button
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => !disableOpen && setOpen(true)}
          className="inline-flex justify-center items-center w-11 h-11 rounded-lg bg-gradient-to-r from-indigo-500 to-blue-600 shadow-md text-white"
        >
          <Filter size={18} />
        </motion.button>
      </div>

      {/* Advanced Search (Desktop) */}
      <div className="hidden md:flex md:justify-end">
        <motion.button
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => !disableOpen && setOpen(true)}
          className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-indigo-500 to-blue-600 shadow-md"
        >
          <span className="inline-flex justify-center items-center w-7 h-7 rounded-full bg-white/20">
            <Filter size={16} />
          </span>
          <span className="flex flex-col leading-tight text-left">
            <span>Advanced Search</span>
            <span className="text-[11px] font-normal text-white/85">Filter & Find</span>
          </span>
        </motion.button>
      </div>
      <AdvancedSearchDrawer open={isOpen} onClose={() => setOpen(false)} onApply={onApply} />
    </div>
  );
}

